import { Button, Label, TextInput } from "flowbite-react";
import { useState } from "react";
import toast from "react-hot-toast";
import { updateUserPassword } from "../../api/auth";
import PasswordRequirements from "./PasswordRequirements";

const Password = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [errors, setErrors] = useState({});

  const validatePassword = password => {
    const errors = {};
    
    if (password.length < 10 || password.length > 100) {
      errors.length = 'Password must be between 10 and 100 characters.';
    }
    
    if (!/[a-z]/.test(password)) {
      errors.lowercase = 'Password must contain at least one lowercase letter.';
    }
    
    if (!/[!@#$%^&*()_+{}":;'?/>.<,]/.test(password)) {
      errors.specialChar = 'Password must include at least one special character.';
    }
    
    return errors;
  }

  const handleChange = e => {
    const { name, value } = e.target;

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newPasswordErrors = validatePassword(formData.newPassword);

    const confirmPasswordError = formData.newPassword !== formData.confirmPassword ? {
      confirmPassword: 'Passwords do not match.',
    } : {};

    const allErrors = { ...newPasswordErrors, ...confirmPasswordError }

    if (Object.keys(allErrors).length > 0) {
      setErrors(allErrors);

      toast.error('Please make sure that all password requirements have been passed.');

      return;
    }

    setIsProcessing(true);
    setErrors({});

    try {
      await updateUserPassword(formData);

      toast.success('Password have been changed successfully');
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message ? error.response.data.message : 'Unable to change password');
    } finally {
      setIsProcessing(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-4 grid gap-4 sm:mb-6 sm:grid-cols-2">
        <div className="col-span-1 space-y-4">
          <div>
            <div className="mb-2 block">
              <Label htmlFor="currentPassword" value="Current password" />
            </div>
            <TextInput
              type="password"
              id="currentPassword"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleChange}
              placeholder="Enter your current password"
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="newPassword" value="Your new password" />
            </div>
            <TextInput
              type="password"
              id="newPassword"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              placeholder="Enter your new password"
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="confirmPassword" value="Confirm new password" />
            </div>
            <TextInput
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm new password"
            />
          </div>
        </div>
        <PasswordRequirements
          password={formData.newPassword}
          oldPassword={formData.currentPassword}
        />
      </div>
      <Button
        isProcessing={isProcessing}
        disabled={isProcessing}
        type="submit"
      >
        Save changes
      </Button>
    </form>
  );
}

export default Password;
